<template>
  <DisplayArticle gap="l" align="center">
    <div class="graphic">
      <ImgLoad
        effect="scale-in"
        alt="calndier"
        class="image"
        src="/images/assessment/coaching.svg"
      />
    </div>

    <div class="infos">
      <DomFade tag="h4" :delay="50">
        <strong>Aucune évaluation en cours !</strong>
      </DomFade>
      <DomFade tag="p" :delay="150">
        Planifie tes prochaines évaluations pour obtenir un calendrier de
        révision et ne rien oublier !
      </DomFade>
    </div>
    <DomFade tag="h4" :delay="250">
      <ButtonBase
        class="button"
        stroke="n"
        theme="secondary"
        size="small"
        rounded
        :to="pathAdd"
        @click.capture="handleClickCreate"
      >
        Ajouter une évaluation
      </ButtonBase>
    </DomFade>
  </DisplayArticle>
</template>
<script setup lang="ts">
import DialogNotASubscriber from '~/components/categories/assessment/dialog/DialogNotASubscriber.vue';

const profile = useProfileStore();

const dialog = useDialogStore();

const pathAdd = computed(() => {
  return `/${Sections.ChildForYou}/eval/ajouter`;
});

const handleClickCreate = (e) => {
  if (profile.canCreateNewAssessment) return;
  dialog.open(DialogNotASubscriber, {
    position: 'center',
    level: DialogLevel.Info,
    onClose: () => {
      navigateTo(`/${Sections.ChildForYou}`);
    },
  });
  return e.preventDefault();
};
</script>
<style lang="scss" scoped>
.section {
  max-width: 40rem;
  margin: 0 auto;
}
h4 {
  text-align: center;
}

.infos {
  text-align: center;
}

.graphic {
  display: flex;
  position: relative;
  justify-content: center;

  @include above('l') {
    .calendar {
      width: 14rem;
      height: auto;
    }
    .check {
      width: 8rem;
      height: auto;
      margin-top: 4rem;
      margin-left: 4rem;
    }
  }
}
.button {
  width: fit-content;
  margin: 0 auto;
}
</style>
